import { ConfirmFileUploadResponse, CreateFileRequest, CreateFileResponse, DeleteFileResponse, GetFileDownloadUrlResponse } from "@/backend/express/controllers/fileController";
import { Client } from "./client";

export class FileController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async create(req: CreateFileRequest): Promise<CreateFileResponse> {
    return this.client.create('/api/files', req);
  }

  public async replace(req: CreateFileRequest): Promise<CreateFileResponse> {
    return this.client.create('/api/files/replace', req);
  }

  public async delete(id: string): Promise<DeleteFileResponse> {
    return this.client.delete(`/api/files/${id}`);
  }

  // A created file stays hidden until this succeeds; the server checks the bytes are in S3.
  public async confirmUpload(id: string): Promise<ConfirmFileUploadResponse> {
    return this.client.create(`/api/files/${id}/confirm`, {});
  }

  public async getS3Url(id: string): Promise<GetFileDownloadUrlResponse> {
    return this.client.read(`/api/files/download-url/${id}`);
  }

  public uploadToS3(uploadUrl: string, file: File, onProgress: (percent: number) => void, signal?: AbortSignal): Promise<Response> {
    return new Promise((resolve, reject) => {
      if (signal?.aborted) {
        reject(new DOMException('Aborted', 'AbortError'));
        return;
      }

      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl);

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          onProgress(Math.round((event.loaded / event.total) * 100));
        }
      });

      xhr.addEventListener('load', () => {
        resolve(new Response(xhr.response as BodyInit | null, {
          status: xhr.status,
          statusText: xhr.statusText,
        }));
      });

      xhr.addEventListener('error', () => reject(new TypeError('Network request failed')));
      xhr.addEventListener('abort', () => reject(new DOMException('Aborted', 'AbortError')));

      signal?.addEventListener('abort', () => xhr.abort(), { once: true });

      xhr.send(file);
    });
  }
}
